"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneInboundAttributionSchema = exports.requestPhoneNumberPortSchema = exports.requestPhoneNumberProvisioningSchema = exports.updatePhoneTrackingNumberRequestSchema = exports.syncOwnedPhoneNumbersResponseSchema = exports.phoneTrackingInventoryResponseSchema = exports.phoneTrackingNumberSchema = exports.phoneTrackingPrivacyPolicySchema = exports.phoneTrackingAssignmentSchema = exports.phoneTrackingCapabilitiesSchema = exports.phoneRecordingConsentModeSchema = exports.phoneNumberProviderHealthSchema = exports.phoneNumberOwnershipStatusSchema = exports.phoneNumberOnboardingStatusSchema = exports.phoneNumberAcquisitionTypeSchema = exports.phoneTrackingNumberIdSchema = void 0;
const zod_1 = require("zod");
const lead_1 = require("./lead");
const trackingE164NumberSchema = zod_1.z.string().regex(/^\+[1-9][0-9]{7,14}$/);
exports.phoneTrackingNumberIdSchema = zod_1.z.string().uuid();
exports.phoneNumberAcquisitionTypeSchema = zod_1.z.enum([
    "EXISTING",
    "PROVISIONED",
    "PORT_IN",
]);
exports.phoneNumberOnboardingStatusSchema = zod_1.z.enum([
    "DRAFT",
    "REQUESTED",
    "IN_REVIEW",
    "ACTION_REQUIRED",
    "ACTIVE",
    "FAILED",
    "CANCELED",
]);
exports.phoneNumberOwnershipStatusSchema = zod_1.z.enum([
    "UNVERIFIED",
    "PROVIDER_CONFIRMED",
]);
exports.phoneNumberProviderHealthSchema = zod_1.z.enum([
    "UNKNOWN",
    "READY",
    "DEGRADED",
    "UNAVAILABLE",
]);
exports.phoneRecordingConsentModeSchema = zod_1.z.enum([
    "NOT_RECORDED",
    "DISCLOSURE_REQUIRED",
    "EXPLICIT_CONSENT_REQUIRED",
]);
exports.phoneTrackingCapabilitiesSchema = zod_1.z.object({
    voice: zod_1.z.boolean(),
    sms: zod_1.z.boolean(),
    mms: zod_1.z.boolean(),
});
exports.phoneTrackingAssignmentSchema = zod_1.z.object({
    operationalLocationId: zod_1.z.string().uuid().nullable(),
    operationalLocationName: zod_1.z.string().trim().min(1).max(120).nullable(),
    campaignKey: zod_1.z.string().trim().min(1).max(120).nullable(),
    campaignName: zod_1.z.string().trim().min(1).max(160).nullable(),
    source: lead_1.leadSourceSchema,
});
exports.phoneTrackingPrivacyPolicySchema = zod_1.z.object({
    smsConsentRequired: zod_1.z.boolean(),
    recordingConsentMode: exports.phoneRecordingConsentModeSchema,
    recordingRetentionDays: zod_1.z.number().int().min(1).max(3_650),
    legalHold: zod_1.z.boolean(),
});
exports.phoneTrackingNumberSchema = zod_1.z.object({
    id: exports.phoneTrackingNumberIdSchema,
    businessId: zod_1.z.string().uuid(),
    e164Number: trackingE164NumberSchema,
    displayName: zod_1.z.string().trim().min(1).max(80),
    acquisitionType: exports.phoneNumberAcquisitionTypeSchema,
    onboardingStatus: exports.phoneNumberOnboardingStatusSchema,
    ownershipStatus: exports.phoneNumberOwnershipStatusSchema,
    capabilities: exports.phoneTrackingCapabilitiesSchema,
    assignment: exports.phoneTrackingAssignmentSchema,
    privacy: exports.phoneTrackingPrivacyPolicySchema,
    providerHealth: exports.phoneNumberProviderHealthSchema,
    providerSafeError: zod_1.z.string().trim().max(500).nullable(),
    lastProviderCheckAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    porting: zod_1.z
        .object({
        providerReferencePresent: zod_1.z.boolean(),
        targetDate: zod_1.z.string().date().nullable(),
        rejectionCode: zod_1.z.string().trim().max(80).nullable(),
    })
        .nullable(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.phoneTrackingInventoryResponseSchema = zod_1.z.object({
    provider: zod_1.z.enum(["LOCAL_CAPTURE", "TWILIO", "UNAVAILABLE"]),
    providerHealth: exports.phoneNumberProviderHealthSchema,
    liveProvisioningAvailable: zod_1.z.boolean(),
    livePortingAvailable: zod_1.z.boolean(),
    safeDiagnostic: zod_1.z.string().trim().max(500).nullable(),
    items: zod_1.z.array(exports.phoneTrackingNumberSchema),
});
exports.syncOwnedPhoneNumbersResponseSchema = zod_1.z.object({
    imported: zod_1.z.number().int().nonnegative(),
    refreshed: zod_1.z.number().int().nonnegative(),
    inventory: exports.phoneTrackingInventoryResponseSchema,
});
const nullableBoundedText = (maximum) => zod_1.z.union([zod_1.z.string().trim().min(1).max(maximum), zod_1.z.null()]).optional();
exports.updatePhoneTrackingNumberRequestSchema = zod_1.z
    .object({
    displayName: zod_1.z.string().trim().min(1).max(80).optional(),
    operationalLocationId: zod_1.z.string().uuid().nullable().optional(),
    campaignKey: nullableBoundedText(120),
    campaignName: nullableBoundedText(160),
    source: lead_1.leadSourceSchema.optional(),
    smsConsentRequired: zod_1.z.boolean().optional(),
    recordingConsentMode: exports.phoneRecordingConsentModeSchema.optional(),
    recordingRetentionDays: zod_1.z.number().int().min(1).max(3_650).optional(),
    legalHold: zod_1.z.boolean().optional(),
})
    .refine((value) => Object.values(value).some((item) => item !== undefined), {
    message: "At least one tracking-number setting is required.",
});
exports.requestPhoneNumberProvisioningSchema = zod_1.z.object({
    e164Number: trackingE164NumberSchema,
    idempotencyKey: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().trim().min(1).max(80).optional(),
    operationalLocationId: zod_1.z.string().uuid().nullable().optional(),
    campaignKey: nullableBoundedText(120),
    campaignName: nullableBoundedText(160),
    source: lead_1.leadSourceSchema.default("PHONE"),
});
exports.requestPhoneNumberPortSchema = zod_1.z.object({
    e164Number: trackingE164NumberSchema,
    idempotencyKey: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().trim().min(1).max(80).optional(),
    operationalLocationId: zod_1.z.string().uuid().nullable().optional(),
    campaignKey: nullableBoundedText(120),
    campaignName: nullableBoundedText(160),
    source: lead_1.leadSourceSchema.default("PHONE"),
});
exports.phoneInboundAttributionSchema = zod_1.z.object({
    trackingNumberId: exports.phoneTrackingNumberIdSchema,
    operationalLocationId: zod_1.z.string().uuid().nullable(),
    operationalLocationName: zod_1.z
        .string()
        .trim()
        .min(1)
        .max(120)
        .nullable()
        .optional(),
    campaignKey: zod_1.z.string().max(120).nullable(),
    campaignName: zod_1.z.string().max(160).nullable(),
    source: lead_1.leadSourceSchema,
    channel: zod_1.z.enum(["PHONE", "SMS"]),
});
//# sourceMappingURL=phone-tracking.js.map